var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDaily(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13303",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_24",
    fill: "#414141",
    d: "M35,44H10C6.1,44,3,40.8,3,36.9V11.9C3,8,6.1,4.9,10,4.9h1.2V10c0,0.9,0.7,1.6,1.6,1.6 c0.9,0,1.6-0.7,1.6-1.6V4.9h15.1V10c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6V4.9H35c3.9,0,7.1,3.2,7.1,7.1v24.9 C42,40.8,38.9,44,35,44L35,44z M10.7,13.4c-2.9,0-5.3,2.4-5.3,5.3v17.5c0,2.9,2.4,5.3,5.3,5.3h23.6c2.9,0,5.3-2.4,5.3-5.3V18.7 c0-2.9-2.4-5.3-5.3-5.3L10.7,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9709",
    fill: "#414141",
    d: "M12.8,11.2c-0.7,0-1.2-0.5-1.2-1.2l0,0V2.3c0-0.7,0.5-1.2,1.2-1.2c0,0,0,0,0,0 C13.5,1,14,1.6,14,2.3l0,0V10C14,10.7,13.5,11.2,12.8,11.2L12.8,11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9710",
    fill: "#414141",
    d: "M31.1,11.2c-0.7,0-1.2-0.5-1.2-1.2l0,0V2.3c0-0.7,0.5-1.2,1.2-1.2c0,0,0,0,0,0 c0.7,0,1.2,0.5,1.2,1.2l0,0V10C32.4,10.7,31.8,11.2,31.1,11.2L31.1,11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4533",
    fill: "#414141",
    d: "M37.2,20v0.3c0,2-1.6,3.5-3.5,3.5H11.4c-2,0-3.5-1.6-3.5-3.5V20c0-2,1.6-3.5,3.5-3.5 h22.2C35.6,16.5,37.2,18.1,37.2,20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4534",
    fill: "#414141",
    d: "M37.2,29.8V30c0,2-1.6,3.5-3.5,3.5H11.4c-2,0-3.5-1.6-3.5-3.5v-0.3 c0-2,1.6-3.5,3.5-3.5h22.2C35.6,26.2,37.2,27.8,37.2,29.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaily);
export default __webpack_public_path__ + "static/media/Daily.1d0fa76b732c1c1f851a3e41f1339df9.svg";
export { ForwardRef as ReactComponent };